module.exports = __webpack_public_path__ + "index/img/vip_icon.53695036.png";